import { ChangeDetectionStrategy, Component, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';
import { LevelNamePipe } from '../../pipes';
import { DefaultValuesComponent } from '../default-values/default-values.component';
import { CalculationBaseComponent } from '../calculation-base/calculation-base.component';
import { LevelsService, RoomByRoomService } from '../../services';
import { AddRoomsEvent, Level } from '../../models';
import { LevelRoomsPanelComponent } from '../level-rooms-panel/level-rooms-panel.component';

@Component({
    selector: 'rbr-calculator',
    imports: [MatButton, TranslateModule, ComponentsModule, DefaultValuesComponent, CalculationBaseComponent, LevelRoomsPanelComponent],
    templateUrl: './room-by-room-calculator.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./room-by-room-calculator.component.scss']
})
export class RoomByRoomCalculatorComponent implements OnInit {
    @ViewChild('addUpperLevelButton') public addUpperLevelButton!: MatButton;
    @ViewChild('addLowerLevelButton') public addLowerLevelButton!: MatButton;
    public calculationSummary = {
        totalHeatLoad: 10,
        totalCoolingLoad: 20,
        totalLivingArea: 100,
        leftoverArea: 50
    };
    public levels: Signal<Level[]>;
    private levelsService = inject(LevelsService);
    private roomByRoomService = inject(RoomByRoomService);

    ngOnInit(): void {
        this.levels = this.levelsService.getLevels();

        this.roomByRoomService.getConfiguration$().subscribe(config => {
            console.log('API Configuration:', config);
        });
    }

    public initLevels(): void {
        this.levelsService.initLevels();
    }

    public addUpperLevel(): void {
        this.addUpperLevelButton.focus();
        this.levelsService.addUpperLevel();
    }

    public addLowerLevel(): void {
        this.addLowerLevelButton.focus();
        this.levelsService.addLowerLevel();
    }

    public deleteLevel(levelId: string): void {
        this.levelsService.deleteLevel(levelId);
    }

    public onAddRooms(event: AddRoomsEvent): void {
        // TODO implement API call to add rooms to the level
        console.log('Rooms to add:', event);
    }
}
